<mat-sidenav-container class="app-main-container">
  <mat-sidenav-content>
    <igo-backdrop [shown]="backdropShown"
      (click)="onBackdropClick()"></igo-backdrop>

    <div class="navbar-container"
      [class.--empty-spacer]="sidenavOpened">
      <igo-menu-button *ngIf="showMenuButton"
        [class.mat-elevation-z2]="!sidenavOpened"
        [sidenavOpened]="sidenavOpened"
        (openSidenav)="onToggleSidenavClick()"></igo-menu-button>

      <igo-search-bar *ngIf="showSearchBar"
        #searchBar
        [class.mat-elevation-z2]="!sidenavOpened"
        [term]="searchBarTerm"
        [termSplitter]="termSplitter"
        [minLength]="minSearchTermLength"
        [searchSettings]="true"
        [forceNA]="appConfig.app?.forceCoordsNA"
        [store]="searchStore"
        (searchTermChange)="onSearchTermChange($event)"
        [pointerSummaryEnabled]="igoSearchPointerSummaryEnabled"
        (pointerSummaryStatus)="onPointerSummaryStatusChange($event)"
        [searchResultsGeometryEnabled]="searchResultsGeometryEnabled"
        (searchResultsGeometryStatus)="onSearchResultsGeometryStatusChange($event)"
        [reverseSearchCoordsFormatEnabled]="igoReverseSearchCoordsFormatEnabled"
        (reverseSearchCoordsFormatStatus)="onReverseCoordsFormatStatusChange($event)"
        (search)="onSearch($event)"
        (clearFeature)="onClearSearch()"
        (searchSettingsChange)="onSearchSettingsChange()">
      </igo-search-bar>
    </div>

    <app-sidenav [map]="map"
      [(opened)]="sidenavOpened"
      (toolChange)="toolChanged($event)"></app-sidenav>

    <igo-map-browser igoMapOffline
      igoWorkspaceUpdator
      [workspaceStore]="workspaceStore"
      igoLongPress
      igoSearchPointerSummary
      [igoSearchPointerSummaryDelay]="500"
      [igoSearchPointerSummaryEnabled]="igoSearchPointerSummaryEnabled"
      igoHoverFeature
      [igoHoverFeatureDelay]="250"
      [igoHoverFeatureEnabled]="true"
      #mapBrowser
      igoQuery
      [waitForAllQueries]="true"
      [queryFeatures]="true"
      [queryFeaturesHitTolerance]="15"
      igoMapContext
      igoLayerContext
      igoDropGeoFile
      [contextUri]="contextUri"
      (query)="onMapQuery($event)"
      [map]="map"
      [igoContextMenu]="contextMenu"
      (menuPosition)="onContextMenuOpen($event)"
      [ngClass]="{ 'igo-attribution-offset': map.layerController.baseLayers.length > 1, 'isCarteAvancee': (isCarteLegere$ | async) === false }"
      [@mapStateX]="sidenavOpened ? 'right' : 'left'"
      (@mapStateX.start)="updateMapBrowserClass()"
      [@mapStateY]="getControlsOffsetY()"
      (@mapStateY.start)="updateMapBrowserClass()">

      <div class="map-actions --vertical --top --right">
        <div class="spinner-spacer"></div>
        <igo-rotation-button class="mat-elevation-z2"
          [showIfNoRotation]="appConfig.showRotationButtonIfNoRotation"
          [map]="map"
          color="primary"></igo-rotation-button>
      </div>

      <div class="map-actions --vertical --bottom --right"
        [@controlsOffsetY]="getControlsOffsetY()"
        [@mobileOffsetY]="getToastPanelStatus()">
        <igo-offline-button [map]="map"
          color="primary"
          *ngIf="appConfig.offlineButton"
          class="mat-elevation-z2"
          [@controlsOffsetY]="getControlsOffsetY()"
          [@mobileOffsetY]="getToastPanelStatus()"></igo-offline-button>
        <igo-home-extent-button *ngIf="appConfig.homeExtentButton"
          class="mat-elevation-z2"
          [map]="map"
          [extentOverride]="homeExtent"
          [centerOverride]="homeCenter"
          [zoomOverride]="homeZoom"
          color="primary">
        </igo-home-extent-button>
        <igo-wake-lock-button *ngIf="appConfig.wakeLockApiButton"
          class="mat-elevation-z2"></igo-wake-lock-button>
        <igo-geolocate-button *ngIf="hasGeolocateButton"
          class="mat-elevation-z2"
          [map]="map"
          color="primary"
          [@controlsOffsetY]="getControlsOffsetY()"
          [@mobileOffsetY]="getToastPanelStatus()"></igo-geolocate-button>
        <igo-zoom-button *ngIf="!isTouchScreen"
          [map]="map"
          color="primary"
          [@controlsOffsetY]="getControlsOffsetY()"></igo-zoom-button>
        <button mat-raised-button
          id="legendBtn"
          [matTooltip]="'legend.tooltip' | translate"
          (click)="openLegend()">{{'legend.label' | translate}}</button>
      </div>

      <div class="map-actions --horizontal --bottom --right"
        [@controlsOffsetY]="getControlsOffsetY()"
        [@mobileOffsetY]="getToastPanelStatus()">
      </div>

      <div class="map-actions --vertical --bottom --left"
        [@controlsOffsetY]="getControlsOffsetY()"
        [@mobileOffsetY]="getToastPanelStatus()">
        <button *ngIf="isCarteLegere$ | async"
          id="couchesBtn"
          class="mat-elevation-z2"
          mat-icon-button
          color="primary"
          (click)="openCouches()"><mat-icon>map</mat-icon></button>
        <igo-baselayers-switcher class="mat-elevation-z2"
          [map]="map"
          [@controlsOffsetY]="getBaselayersSwitcherStatus()"
          [useStaticIcon]="true"></igo-baselayers-switcher>
        <app-expansion-panel-button
          *ngIf="appConfig.hasExpansionPanel && (workspaceState.workspaceEnabled$ | async) && !expansionPanelExpanded"
          [expanded]="expansionPanelExpanded"
          (expand)="handleToggleExpansionPanel($event)"></app-expansion-panel-button>
      </div>

      <!-- <igo-swipe-control class="mat-elevation-z2" [map]="map"></igo-swipe-control> -->
      <igo-map-center class="mat-elevation-z2"
        [map]="map"></igo-map-center>
    </igo-map-browser>

    <app-map-overlay [@controlStateY]="getControlsOffsetY()"
      [@controlStateX]="(mediaService.media$ | async) !== 'mobile' && sidenavOpened ? 'right' : 'left'"></app-map-overlay>
  </mat-sidenav-content>
</mat-sidenav-container>

<app-expansion-panel *ngIf="expansionPanelExpanded"
  [backdropShown]="expansionPanelBackdropShown"
  [(expanded)]="expansionPanelExpanded"
  [maximized]="workspaceState.workspaceMaximize$ | async"
  [@expansionPanelSize]="getExpansionPanelStatus()"
  [@toastOffsetY]="isMobile() && !toastPanelOpened && queryState.store.entities$.value.length > 0 && !expansionPanelExpanded ? 'true' : 'false'">
  <ng-container expansionPanelHeader>
    <igo-workspace-selector igoWorkspaceSelector
      (changeWorkspace)="workspaceState.setActiveWorkspaceByTitle($event)"
      (disableSwitch)="workspaceSwitchDisabled = $event"
      (relationLayers)="refreshRelationsWorkspace($event)"
      (rowsInMapExtentCheckCondition)="workspaceState.rowsInMapExtentCheckCondition$.next($event)"
      [store]="workspaceStore"
      [disabled]="workspaceSwitchDisabled"
      [map]="map"></igo-workspace-selector>

    <ng-container *ngIf="selectedWorkspace$ | async as workspace">
      <div class="workspace-container">
        <div class="workspace-actions">
          <button class="eye-workspace"
            mat-icon-button
            [color]="workspace.layer.visible ? 'primary' : 'default'"
            collapsibleButton
            tooltip-position="below"
            matTooltipShowDelay="500"
            [matTooltip]="workspace.layer.visible ? ('igo.geo.layer.hideLayer' | translate) : ('igo.geo.layer.showLayer' | translate)"
            (click)="workspace.layer.visible = !workspace.layer.visible">
            <mat-icon [ngClass]="{ disabled: (workspace.inResolutionRange$ | async) !== true }">
              {{ workspace.layer.visible ? 'visibility' : 'visibility_off' }}
            </mat-icon>
          </button>
          <button *ngIf="isEditionWorkspace(workspace)"
            class="add-feature"
            mat-icon-button
            color="primary"
            collapsibleButton
            tooltip-position="below"
            matTooltipShowDelay="500"
            [disabled]="workspace.layer.options.sourceOptions.edition.addButton === false ? true : false"
            [matTooltip]="'workspace.addFeature' | translate"
            (click)="addFeature(workspace)">
            <mat-icon>add</mat-icon>
          </button>

          <igo-actionbar class="actionbar-workspace"
            *ngIf="workspace.actionStore"
            [store]="workspace.actionStore"
            [withIcon]="true"
            [withTitle]="actionbarWithTitle"
            [horizontal]="true"
            [withToggleButton]="actionbarMode === 'overlay'"
            [iconColor]="'primary'"
            [color]="'primary'"
            [mode]="actionbarMode"
            [overlayClass]="workspaceMenuClass"></igo-actionbar>

          <button class="zoom-workspace"
            *ngIf="workspaceVisibility()"
            [disabled]="(workspaceState.workspaceSelection$ | async).length === 0 ? true : false"
            mat-icon-button
            color="primary"
            collapsibleButton
            tooltip-position="below"
            matTooltipShowDelay="500"
            [matTooltip]="'toastPanel.zoomOnFeaturesTooltip' | translate"
            (click)="zoomToSelectedFeatureWks()">
            @if ((workspaceState.workspaceSelection$ | async).length > 1) {
            <mat-icon>frame_inspect</mat-icon>
            } @else {
            <mat-icon>zoom_in </mat-icon>
            }
          </button>
        </div>

        <igo-entity-table-paginator *ngIf="workspaceVisibility()"
          [store]="workspace.entityStore"
          [entitySortChange$]="workspaceEntitySortChange$"
          [paginatorOptions]="paginatorOptions"
          (paginatorChange)="paginatorChange($event)"></igo-entity-table-paginator>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="selectedWorkspace$ | async as workspace">
    <igo-entity-table [class]="isEditionWorkspace(workspace) ? 'edition-table' : ''"
      [paginator]="workspacePaginator"
      *ngIf="workspace.entityStore && workspace.meta && workspace.meta.tableTemplate && workspaceVisibility()"
      [store]="workspace.entityStore"
      (entitySortChange)="entitySortChange()"
      (entitySelectChange)="entitySelectChange($event)"
      [template]="workspace.meta.tableTemplate">
    </igo-entity-table>

    <span>{{ workspaceNotAvailableMessage | translate }}</span>
  </ng-container>
</app-expansion-panel>

<app-toast-panel-for-expansion [withHeader]="false"
  [(opened)]="toastPanelForExpansionOpened">
  <div class="toast-panel-for-expansion-close-button-container">
    <button mat-icon-button
      color="warn"
      (click)="toastPanelForExpansionOpened = false">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <igo-workspace-widget-outlet *ngIf="selectedWorkspace$ | async as workspace"
    [workspace]="workspace"
    (deactivateWidget)="onDeactivateWorkspaceWidget()"></igo-workspace-widget-outlet>
</app-toast-panel-for-expansion>

<app-toast-panel *ngIf="(queryStore.empty$ | async) !== true"
  [map]="map"
  [store]="queryStore"
  [hasFeatureEmphasisOnSelection]="appConfig.hasFeatureEmphasisOnSelection"
  [@toastPanelOffsetX]="toastPanelOffsetX$ | async"
  [@toastPanelOffsetY]="getToastPanelOffsetY()"
  [@toastPanelMobileSidenav]="(isMobile() && sidenavOpened) || (isTablet() && isPortrait() && sidenavOpened)"
  [opened]="toastPanelOpened"
  (openedChange)="toastOpenedChange($event)"
  (fullExtentEvent)="fullExtent = $event"
  (windowHtmlDisplayEvent)="setToastPanelHtmlDisplay($event)">
</app-toast-panel>

<ng-template #contextMenu>
  <igo-actionbar [store]="contextMenuStore"
    [withIcon]="false"
    [horizontal]="true"
    mode="context"></igo-actionbar>
</ng-template>